module.exports = __webpack_public_path__ + "static/img/2_04.870ea22d.jpg";